/**
 * Ücretsiz kargo çubuğundaki (sepet çekmecesi ve sepet sayfası) fındık ezmesi "Ekle" butonları.
 * Sayfayı değiştirmeden ürünü sepete ekler ve temasın kendi sepet olayını (CartLinesUpdateEvent)
 * tetikleyerek çekmece/sepet içeriğini, sepet simgesini ve çubuğu yeniler.
 *
 * Not: Form, JS çalışmazsa /cart/add'e normal POST yapar (yedek davranış).
 */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-fsb-add]')) return;

  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled) return;

  const bar = form.closest('.free-shipping-bar');
  const errorEl = bar ? bar.querySelector('[data-fsb-error]') : null;
  const variantId = String(form.elements.id.value);
  const idleText = button.textContent;

  if (errorEl) errorEl.textContent = '';
  button.disabled = true;
  button.textContent = 'Ekleniyor...';

  const sectionIds = [
    ...new Set(
      [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean)
    ),
  ];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  const addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

  try {
    const response = await fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });
    const result = await response.json();
    const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const ajaxCart = await cartResponse.json();
    const cart = CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart);

    if (!response.ok || result.status) {
      const message = result.description || result.message || 'Sepete eklenemedi.';
      form.dispatchEvent(
        new CartErrorEvent({
          error: message,
          code: 'INVALID',
          detail: { description: result.description, errors: result.errors },
        })
      );
      deferred.resolve({
        cart,
        detail: {
          didError: true,
          items: ajaxCart.items,
          source: 'free-shipping-bar',
          sourceId: variantId,
          itemCount: 1,
        },
      });
      if (errorEl && errorEl.isConnected) errorEl.textContent = message;
      button.textContent = idleText;
      button.disabled = false;
      return;
    }

    deferred.resolve({
      cart,
      detail: {
        items: ajaxCart.items,
        source: 'free-shipping-bar',
        sourceId: variantId,
        itemCount: 1,
        sections: result.sections,
        didError: false,
      },
    });

    button.textContent = 'Eklendi';
    setTimeout(() => {
      if (!button.isConnected) return;
      button.textContent = idleText;
      button.disabled = false;
    }, 1500);
  } catch (error) {
    deferred.reject(error);
    button.textContent = idleText;
    button.disabled = false;
    if (errorEl && errorEl.isConnected) errorEl.textContent = 'Bir sorun oluştu, lütfen tekrar deneyin.';
  }
});
